import localDB from "./localDB";

let GLOBAL = require('./globals');

const RecipeIngredientData = {
    async list(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/recipe-ingredients/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipe-ingredient/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipe-ingredient/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipe-ingredients/${data.recipe}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    }
};

export default RecipeIngredientData;


// WEBPACK FOOTER //
// ./src/data/RecipeIngredientData.js